export default __webpack_public_path__ + "static/imagem-form-8720ef4d38b584533caaed582f23818f.png";